<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="商品名称" prop="goodsName">
        <el-input v-model.trim="queryParams.goodsName" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品名称" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="仓库" prop="wareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" @change="handleQuery" clearable :props="defaultProps"
          v-model="wareHouseId" placeholder="请选择仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品编号" prop="goodsSn">
        <el-input v-model.trim="queryParams.goodsSn" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品编号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="单品编号" prop="spuSn">
        <el-input v-model.trim="queryParams.spuSn" clearable @keyup.enter.native="handleQuery" placeholder="请输入单品编号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="过期状态" prop="spuExpireStatus">
        <el-select-dict :dictType="{ type: 'EXPIRE_STATUS', filters: '0', reverse: true }" clearable
          placeholder="请选择过期状态" v-model="queryParams.spuExpireStatus" @dictChange="handleQuery"></el-select-dict>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['inventory:out:list']" size="mini" type="primary" plain icon="el-icon-sell" @click="$router.push({ name: 'inventoryOutManage' })">出库</el-button>

        <div class="fr">
          <span class="field">过期预警邮件通知</span>
          <el-switch v-model="expireEmailWarning" @change="handleExpireEmailWarningChange">
          </el-switch>
        </div>
      </div>
      <div class="table-box">
        <auto-height-table :class="{ 'empty': list.length === 0 }" empty-text=" " v-loading="loading"
          :data="list">
          <el-table-column label="商品信息" prop="goodsName" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info flex-c-s">
                <div class="goods-info-left">
                  <img @click.stop="mixinHandlePreview(scope.row.goodsImgs && scope.row.goodsImgs.split(','))"
                    :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])" width="40px" height="40px"
                    alt="商品图片">
                </div>
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">名称：</span>
                    <span class="value">{{ scope.row.goodsName
                    }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <el-link v-if="mixinHasPermi(['inventory:statistics:list'])" type="primary"
                      @click="handleGo('goodsSn', scope.row.goodsSn)">{{ scope.row.goodsSn }}</el-link>
                    <span v-else class="value">{{ scope.row.goodsSn }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格信息" prop="skuListStr" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info-right flex-c-c flex-col">
                <div class="top">
                  <span class="label">规格：</span>
                  <span class="value">{{ scope.row.skuListStr }}</span>
                </div>
                <div class="bottom">
                  <span class="label">编号：</span>
                  <el-link v-if="mixinHasPermi(['inventory:statistics:list'])" type="primary"
                      @click="handleGo('spuSn', scope.row.spuSn)">{{ scope.row.spuSn }}</el-link>
                    <span v-else class="value">{{ scope.row.spuSn }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="仓库" prop="wareHouseName" align="center" min-width="156px">
            <template slot-scope="scope">
              {{ getWareHouseName(scope.row.wareHouseId) }}
            </template>
          </el-table-column>
          <el-table-column label="生产日期" prop="manufactureDate" align="center" min-width="128px" />
          <el-table-column label="成本单价(元)" prop="costPrice" align="center" min-width="128px" />
          <el-table-column label="保质期(天)" prop="qualityGuaranteePeriod" align="center" min-width="128px" />
          <el-table-column label="保质期预警(天)" prop="qualityGuaranteePeriodWarning" align="center" min-width="128px" />
          <el-table-column-dict dictTypeNode="tag" dictType="EXPIRE_STATUS" label="过期状态" prop="spuExpireStatus"
            align="center" min-width="128px" />
          <el-table-column label="库存数量" prop="spuNumber" align="center" min-width="128px" />
          <el-table-column label="备注" prop="expireDay" align="center" min-width="156px">
            <template slot-scope="scope">
              {{ scope.row.spuExpireStatus === "1" ?
                "距离过期仅剩" + scope.row.expireDay + "天" :
                scope.row.spuExpireStatus === "2" ? "已过期" + scope.row.expireDay + "天" :
                  "--" }}
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
  </div>
</template>

<script>
import { statisticsApi, wareHouseApi } from "@/api"
import { getPathByTreeValue, debounce } from "vue2-element-admin-plugin"
import {markNonLeafNodes} from "@/utils/tree"
export default {
  name: "inventoryExpireWarningManage",
  data() {
    return {
      expireEmailWarning: true, // 开启邮件通知
      wareHouseData: [],
      wareHouseId: [],
      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      //搜索条件参数
      queryParams: {
        goodsName: "", // 商品名称
        goodsSn: "", // 商品编号
        spuSn: "", // 单品编号
        spuExpireStatus: "", // 过期状态
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      loading: false,
      total: 0,
      isBtnTrigger: false, // 是否触发了按钮
      currentTotal: 0 // 记录旧的总数 总数变了的时候 刷新角标
    }
  },
  async created() {
    this.expireEmailWarning = this.mixinUserInfo.expireEmailWarning === "1" // 是否过期预警邮件通知
    await this.getWareHouseTree()
    //获取列表
    this.getList()
  },
  methods: {
    // 开启邮件通知
    handleExpireEmailWarningChange: debounce(function(val) {
      const expireEmailWarning = val ? "1" : "0"
      if (expireEmailWarning === this.mixinUserInfo.expireEmailWarning) {
        return
      }
      const msg = val ? "过期预警邮件通知开启成功" : "过期预警邮件通知关闭成功"
      statisticsApi.changeExpireEmailWarning({ expireEmailWarning }).then(res => {
        // 设置用户过期预警信息
        this.$store.commit("user/SET_USER_INFO", { ...this.mixinUserInfo, expireEmailWarning })
        this.$message.success(msg)
      })
    }, 800),
    // 获取仓库列表
    getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = markNonLeafNodes(data, this.mixinWareHouseIdList, {idField: "wareHouseId"})
      })
    },
    // 获取仓库名字
    getWareHouseName(val) {
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 点击前往库存统计查询
    handleGo(key, value) {
      if (!this.mixinHasPermi(["inventory:statistics:list"])) {
        return
      }
      this.$router.push({
        name: "inventoryStatisticsManage",
        query: {
          [key]: value
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.isBtnTrigger = true // 点击按钮触发的搜索
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.wareHouseId = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      // 获取仓库id
      if (this.wareHouseId && this.wareHouseId.length > 0) {
        this.queryParams.wareHouseId = this.wareHouseId[this.wareHouseId.length - 1]
      } else {
        this.queryParams.wareHouseId = ""
      }
      statisticsApi
        .getExpireWarningList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          if (this.isBtnTrigger) {
            if (this.total !== this.currentTotal) {
              this.$store.dispatch("user/getUserInfo").then(data => {
                this.currentTotal = this.total
              })
            }
          } else { // 第一次渲染直接赋值
            this.currentTotal = response.currentTotal
          }
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.field {
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
}

.total-box {
  padding: 24px;
  font-size: 18px;
  background: #fff;
  border-radius: 4px;
  margin-top: 12px;

  .money-info {
    margin-right: 60px;
  }
}
</style>